import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListSectors } from "../../../components/Admin/Sectors/ListSectors/ListSectors";
import { useLanguage } from "../../../contexts";
import "./Sectors.scss";

export function Sectors() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_sectors"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListSectors sectorsActive={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_sectors"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListSectors sectorsActive={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="sectors-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="sectors-page-header-wrapper">
        <div className="sectors-page-header">
          <span className="sectors-page-title">{t("sectors")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
